<template>
  <div class="m-activity-addCouponSell">
    <div class="title">基本设置</div>
    <el-form v-if="isEdit" ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="160px">
      <el-form-item label="活动名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入活动名称" class="input" />
      </el-form-item>
      <el-form-item label="活动时间" prop="activityDate">
        <el-date-picker
          v-model="form.activityDate"
          type="datetimerange"
          range-separator=""
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="是否按时间段售卖" prop="preheat">
        <el-radio-group v-model="form.preheat">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="售券场景" prop="zoneId">
        <el-select v-model="form.zoneId" @change="onZoneChange" placeholder="请选择售券场景">
          <el-option label="售券中心" value="All"></el-option>
          <el-option v-for="(item, index) in zoneList" :label="item.name" :value="item.id" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.preheat == '1'" label="" prop="salesTime" style="margin-left: 70px;">
        <el-time-picker
          is-range
          v-model="form.salesTime"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
          value-format="HHmmss"
          @focus="salesTimeFocus"
        ></el-time-picker>
      </el-form-item>
      <el-form-item label="券渠道" prop="channel">
        <el-radio-group  v-model="form.channel" :disabled="!!$route.query.id && $route.query.page !== 'copy'" @change="onChannelChange" >
          <el-radio label="RT">闰土自制</el-radio>
          <auth-button auth="market:coupon:center:read">
            <!-- <el-radio label="VoucherCenter">券中台投放</el-radio> -->
          </auth-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="券类型" prop="couponKind">
        <el-radio-group v-model="form.couponKind" @change="onCouponKindChange" :disabled="isKeyEdit(form.status)" >
          <el-radio label="Coupon" value="Coupon">优惠券</el-radio>
          <el-radio v-if="form.channel == 'RT'" label="GiftCoupon" value="GiftCoupon">礼品券</el-radio>
          <auth-button auth="market:deductcoupon:template:read">
            <el-radio v-if="form.channel == 'RT' && form.zoneId =='All' " label="DeductCoupon" value="DeductCoupon">抵扣券</el-radio>
          </auth-button>
          <el-radio v-if="form.channel == 'VoucherCenter' && form.zoneId =='All' " label="WelfareCoupon">福利券</el-radio>
          <el-radio v-if="form.channel == 'VoucherCenter' && form.zoneId =='All'" label="Recharge">直充商品</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="选择券" prop="couponTemplateId" v-if="form.channel == 'RT'">
        <el-select v-model="form.couponTemplateId" :disabled="isKeyEdit(form.status)" placeholder="请选择优惠券" @change="onCouponChange" filterable >
          <el-option v-for="item in couponSelectData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择券" prop="channelBizChild" v-if="form.channel=='VoucherCenter'">
        <el-cascader
          v-model="form.channelBizChild"
          placeholder="请选择券"
          :options="couponSelectData"
          :props="categoryCascaderProps"
          :disabled="!!$route.query.id && $route.query.page !== 'copy' && form.channel=='VoucherCenter'"
          clearable
          ref="category"
          @change="onCouponChange"
          filterable
        ></el-cascader>
      </el-form-item>
      <!-- <el-form-item label="选择券" prop="channelBizChild" v-if="form.channel == 'VoucherCenter' && form.couponKind == 'WelfareCoupon'">
        <el-select v-model="form.channelBizChild" @change="onCouponChange" :disabled="!!$route.query.id && $route.query.page !== 'copy' && form.channel=='VoucherCenter'" filterable >
          <el-option v-for="item in couponSelectData" :key="item.refId" :label="item.productName" :value="item.refId"></el-option>
        </el-select>
      </el-form-item> -->
      <div class="coupon-table" >
        <coupon-table :tableTrData="tableTrData" :couponType="couponType"></coupon-table>
      </div>
      <div class="price-input-box">
        <el-form-item label="售价" prop="price">
          <el-input v-model="form.price" placeholder="请输入" :disabled="isKeyEdit(form.status)" oninput="value=value.replace(/[^.\d.]/g,'')" >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="form.couponKind != 'WelfareCoupon' && form.couponKind != 'Recharge'" label="——" prop="point" label-width="50px">
          <el-input v-model="form.point" :disabled="isKeyEdit(form.status)" placeholder="请输入" oninput="value=value.replace(/[^\d]/g,'')" >
            <template slot="append">积分</template>
          </el-input>
          <span class="input-remark">（不允许单独设置积分支付）</span>
        </el-form-item>
      </div>
      <el-form-item label="追加" prop="appendAmount" v-if="!!$route.query.id && ($route.query.page !== 'copy') && (form.channel == 'VoucherCenter'&&form.couponKind=='Coupon')">
        <el-input v-model="form.appendAmount" placeholder="请输入追加数量" class="input" />
      </el-form-item>
      <div class="coupon-table" v-if="!!$route.query.id && ($route.query.page !== 'copy') && (form.channel == 'VoucherCenter') && (!!voucherCenter_tableTrData.length)">
        <Table :tableThData="voucherCenter_tableThData" :tableTrData="voucherCenter_tableTrData" :pagination="false" >
          <template #updated="{ row }">{{ row.updated ? $moment(row.updated).format('YYYY/MM/DD HH:mm:ss') : '---'}}</template>
          <template #sort="{ row }">{{ row.sort }}</template>
          <template #amount="{ row }">{{ row.amount }}</template>
        </Table>
      </div>
      <el-form-item label="售卖数量" prop="amount">
        <el-input v-model="form.amount" placeholder="请输入售卖数量" oninput="value=value.replace(/[^\d]/g,'')" :disabled="!!$route.query.id && ($route.query.page !== 'copy') && (form.channel != 'RT')" />
      </el-form-item>
      <el-form-item label="是否隐藏券" prop="hidden" v-if="form.couponKind != 'DeductCoupon'">
        <el-radio-group v-model="form.hidden" @change="onHiddenChange">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="form.hidden === false">
        <el-form-item v-if="form.couponKind == 'WelfareCoupon' || form.couponKind == 'Recharge'" label="渠道" prop="deliveryChannel">
          <el-radio-group v-model="form.deliveryChannel" :disabled="true">
            <el-radio label="WelfareCoupon">权益聚合页</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="deliveryChannel" v-if=" !(form.couponKind == 'DeductCoupon' || form.couponKind == 'WelfareCoupon' || form.couponKind == 'Recharge')">
            <span slot="label">
              <span class="span-box">
                <span>是否同步首页</span>
                  <el-tooltip class="item" effect="dark" placement="bottom">
                    <div slot="content">
                      “是”表示该售券活动在售券中心及团购券展示<br/>
                      “否”表示该售券活动只在售券中心展示<br/>
                    </div>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
              </span>
            </span>
           <el-radio-group  v-model="form.deliveryChannel"  @change="onDeliveryChannelChange">
            <el-radio label="SellCoupon">否</el-radio>
            <el-radio label="First">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="sort" v-if="form.deliveryChannel == 'First'">
          <span slot="label">
            <span class="span-box">
              <span>渠道序号</span>
              <el-tooltip class="item" effect="dark" placement="bottom">
                <div slot="content">渠道序号排序规则只在团购券有效，售券中心不生效</div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
          </span>
          <el-input v-model="form.sort" placeholder="请输入渠道序号"  oninput="value=value.replace(/^(0+)|[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item prop="sorted">
          <span slot="label">
            <span class="span-box">
              <span>活动序号（选填）</span>
              <el-tooltip class="item" effect="dark" placement="bottom">
                <div slot="content">活动序号排序规则只在售券中心生效，团购券不生效</div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
          </span>
          <el-input v-model="form.sorted" placeholder="请输入活动序号" oninput="value=value.replace(/^(0+)|[^\d]/g,'')"></el-input>
        </el-form-item>
      </template>
      <el-form-item label="券每天总卖限制" prop="dailyTotal">
        <el-radio-group v-model="form.dailyTotal" @change="limitRadioChange('dailyTotalLimit')">
          <el-radio label="1">无限制</el-radio>
          <el-radio label="2" class="limit-pay-box">
            <span>每天总限卖</span>
            <el-form-item label="" prop="dailyTotalLimit">
              <el-input v-model="form.dailyTotalLimit" placeholder="请输入" :disabled="form.dailyTotal !== '2'" oninput="value=value.replace(/[^\d]/g,'')" >
                <template slot="append">张</template>
              </el-input>
            </el-form-item>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="每日限买次数" prop="userDaily">
        <el-radio-group v-model="form.userDaily" @change="limitRadioChange('userDailyLimit')">
          <el-radio label="1">无限制</el-radio>
          <el-radio label="2" class="limit-pay-box">
            <span>每天总限买</span>
            <el-form-item label="" prop="userDailyLimit">
              <el-input v-model="form.userDailyLimit" placeholder="请输入" :disabled="form.userDaily !== '2'" oninput="value=value.replace(/[^\d]/g,'')" >
                <template slot="append">张</template>
              </el-input>
            </el-form-item>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="用户总买限制" prop="userTotal">
        <el-radio-group v-model="form.userTotal" @change="limitRadioChange('userTotalLimit')">
          <el-radio label="1">无限制</el-radio>
          <el-radio label="2" class="limit-pay-box">
            <span>用户总限买</span>
            <el-form-item label="" prop="userTotalLimit">
              <el-input v-model="form.userTotalLimit" placeholder="请输入" :disabled="form.userTotal !== '2'" oninput="value=value.replace(/[^\d]/g,'')" >
                <template slot="append">张</template>
              </el-input>
            </el-form-item>
          </el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="发放用户" prop="useRange">
        <el-radio-group v-model="form.useRange" :disabled="form.hidden">
          <el-radio label="AllUser">所有用户</el-radio>
          <!-- <auth-button auth="market:activity:portrait">
            <el-radio label="SpecifyUser">指定画像</el-radio>
          </auth-button> -->
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item v-if="form.useRange == 'SpecifyUser'" prop="portraitIds" label="" label-width="230px" >
        <el-select v-model="form.portraitIds" placeholder="请选择画像（最多可选3条）" filterable multiple collapse-tags :multiple-limit="3">
          <el-option v-for="item in portrayalData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item label="过期自动退款" prop="refundable">
        <el-radio-group v-model="form.refundable" :disabled="form.couponKind == 'WelfareCoupon' || form.couponKind == 'Recharge'">
          <el-radio :label="true">允许自动退款</el-radio>
          <el-radio :label="false">不允许自动退款</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="范围类型" prop="scopeType">
        <el-radio-group v-model="form.scopeType" :disabled="form.hidden">
          <el-radio label="AllMall">所有商场</el-radio>
          <el-radio label="Mall">指定商场</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.scopeType == 'Mall'" prop="mallIds" label="" label-width="270px" >
        <el-select v-model="form.mallIds" placeholder="请选择商场" filterable multiple collapse-tags>
          <el-option v-for="item in mallData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <detail v-else :form="form" :tableTrData="tableTrData" :filterMallData="filterMallData" :couponType="couponType"></detail>

    <div v-if="isEdit" class="button-box">
      <el-button @click="onCancel" class="mr20">取消</el-button>
      <el-button type="primary" @click="onNextStep" :loading="submitLoading">完成</el-button>
    </div>
    <div v-else-if="isCanEdit" class="button-box right">
      <auth-button auth="market:activity:update">
        <el-button type="primary" @click="() => this.isEdit = true" :loading="submitLoading">编辑</el-button>
      </auth-button>
    </div>

    <div class="buyer-box" v-if="$route.query.page == 'detail'">
      <el-divider />
      <div class="title">购买用户</div>
      <BuyerList v-if="form.id" :couponKind="form.couponKind"></BuyerList>
    </div>
    <el-dialog :visible="isShowRemarkDialog" title="使用须知" :before-close="() => this.isShowRemarkDialog = false" width="30%">
      <div class="remark-box" v-html="currentRow.description"></div>
    </el-dialog>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import UploadImg from '@/components/UploadImg/index'
import BuyerList from './components/buyerList.vue'
import Detail from './components/detail.vue'
import CouponTable from '../components/couponTable.vue'
import Table from "@/components/Table/index";

import { api_getActivityBaseInfo, api_postAddCouponSell, api_putUpdateCouponSell, api_getGiftCouponDetail, api_getCouponDetail, api_getCouponTemplateList, api_getCouponTemplate, api_getWelfareCouponAll, api_getVCWelfareCouponTemplate , api_getActivityZoneList, api_getDeductCouponSelect,api_getDeductCouponTemplate } from '@/api/market'
import { api_getListPortrait, api_getListCoupon, api_getGiftListCoupon, api_getConfig } from '@/api/common'

export default {
  name: "marketActivityListAddCS",
  components: {
    AuthButton,
    UploadImg,
    Table,
    BuyerList,
    Detail,
    CouponTable
  },
  data() {
    // 校验积分
    const checkIntegral = (rule, value, callback) => {
      if ((value + '') && value < 0) {
        callback(new Error('请输入大于0的值'))
      } else {
        callback()
      }
    }

    // 校验张数限制
    const checkLimit = (rule, value, callback) => {
      const { field } = rule
      const radioField = field.split('Limit')[0]
      if (this.form[radioField] == '2' && !value) {
        callback(new Error('请输入'))
      } else if (value <= 0) {
        callback(new Error('请输入大于0的值'))
      } else {
        callback()
      }
    }

    return {
      loadingID: null,
      submitLoading: false,
      isEdit: true, // 基本信息是否是编辑状态
      isCanEdit: true, // 活动是否可编辑
      form: {
        channel:'RT',
        zoneId:"All",
        couponKind: 'Coupon',
        useRange: 'AllUser',
        dailyTotal: '1',
        userDaily: '1',
        userTotal: '1',
        preheat: '0',
        deliveryChannel: 'SellCoupon',
        salesTime: ['000000', '235959'],
        hidden: false
      },
      zoneList:[],
      rules: {
        name: [{ required: true, message: '请输入活动名称' }],
        activityDate: [{ required: true, message: '请选择活动时间' }],
        salesTime: [{ required: true, message: '请选择时间' }],
        sort: [{ required: true, message: '请输入序号' }],
        couponKind: [{ required: true, message: '请选择券类型' }],
        couponTemplateId: [{required: true, message: '请选择优惠券'}],
        amount: [{required: true, message: '请输入发放数量'}],
        useRange: [{required: true, message: '请选择发放用户'}],
        price: [{required: true, message: '请输入售价'}],
        point: [{validator: checkIntegral}],
        dailyTotal: [{required: true, message: '请选择'}],
        userDaily: [{required: true, message: '请选择'}],
        userTotal: [{required: true, message: '请选择'}],
        dailyTotalLimit: [{validator: checkLimit}],
        userDailyLimit: [{validator: checkLimit}],
        userTotalLimit: [{validator: checkLimit}],
        scopeType: [{required: true, message: '请选择范围类型'}],
      },

      couponSelectData: [], // 券下拉框数据
      couponListData: [], // 优惠券list数据
      couponCenterListData:[], // 券中台优惠券list数据
      vcWelfareCouponListData:[], // 券中台福利券list数据
      vcRechargeListData:[], // 券中台福利券list数据
      giftCouponListData: [], // 礼品券list数据
      deductCouponListData:[], // 抵扣券list数据
      portrayalData: [], // 画像数据
      tableTrData: [],
      isShowRemarkDialog: false,
      currentRow: {},
      mallData: [], // 商场数据
      filterMallData: [],
      couponType: 'Coupon',

      categoryCascaderProps: {
        value: "id",
        label: "name",
      },

      voucherCenter_tableTrData:[], //券中台追加记录列表
      voucherCenter_tableThData:[
        { prop: "updated", label: "追加时间", minWidth: "200", },
        { prop: "sort", label: "追加次数", minWidth: "90", },
        { prop: "amount", label: "追加数量", minWidth: "120", },
      ],//券中台追加记录列表
    };
  },
  async created() {
    this.loadingID = this.$baseLoading(6)
    await this.getCouponListData() // 获取优惠券列表数据
    await this.getGiftCouponListData() // 获取礼品券列表数据
    await this.getCouponCenterListData() // 获取券中台优惠券券列表数据
    await this.getVcWelfareCouponListData('WelfareCoupon') // 获取券中台福利券券列表数据
    await this.getVcWelfareCouponListData('Recharge') // 获取券中台福利券券列表数据
    await this.getDeductCouponListData() // 获取抵扣券列表数据
    
    // await this.getPortrayalData() // 获取画像数据
    await this.getConfigData() // 获取config
    this.form.type = this.$route.query.type
    if (this.$route.query.id) {
      this.getDetailData() // 获取详情数据
    }
    this.loadingID.close()
  },
  mounted() {
      this.getActivityZoneList()
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      try {
        this.isEdit = false
        let res = await api_getActivityBaseInfo({id: this.$route.query.id})

        res.dailyTotal = res.dailyTotalLimit || res.dailyTotalLimit === 0 ? '2' : '1'
        res.userDaily = res.userDailyLimit || res.userDailyLimit === 0 ? '2' : '1'
        res.userTotal = res.userTotalLimit || res.userTotalLimit === 0 ? '2' : '1'
        res.appendSkuRecord.map((item,index)=>{
          item.sort =  `第${index+1}次`
          return item
        })
        this.voucherCenter_tableTrData =  res.appendSkuRecord || []

        this.onCouponKindChange(res.couponKind) // 券下拉数据
        if (res.channel == 'RT' && res.couponKind == 'Coupon') {
          this.getCouponDetail(res.couponTemplateId) // 获取优惠券详情数据
        } else if (res.couponKind == 'GiftCoupon') {
          this.getGiftCouponDetail(res.couponTemplateId) // 获取礼品券详情数据
        } else if ( res.channel == 'VoucherCenter' && res.couponKind == 'Coupon') {
          this.getVoucherCenterDetail(res.channelBizChildRefId, res.channelBizRefId) // 券中台优惠券详情
        } else if (res.couponKind == 'WelfareCoupon') {
          this.getVCWelfareCouponDetail(res.couponTemplateId,res.couponKind) // 券中台福利券券详情
        }else if (res.couponKind == 'Recharge') {
          this.getVCWelfareCouponDetail(res.couponTemplateId,res.couponKind) // 券中台直充商品详情
        }else if (res.couponKind == 'DeductCoupon') {
          this.getDeductCouponTemplate(res.couponTemplateId) // 抵扣券券详情
        }
        
        

        // 处理是否按时间段售卖
        if (res.salesStartTime && res.salesEndTime) {
          res.salesTime = [res.salesStartTime, res.salesEndTime]
          res.salesTime_show = [this.getTimeStr(res.salesStartTime), this.getTimeStr(res.salesEndTime)]
          res.preheat = '1'
        } else {
          res.salesTime = ['000000', '235959']
          res.preheat = '0'
        }

        console.log('基本信息res: ', res);
        let zoneItem = this.zoneList.filter(item => item.id == res.zoneId)
        this.form = {
          ...res,
          activityDate: [res.startTime, res.endTime], // 活动时间
          scopeType: res.mallIds && res.mallIds.length ? 'Mall' : 'AllMall',
          channelBizChild: res.channel=='VoucherCenter'&&res.couponKind!='Coupon'?[res.channelBizChannelRefId,res.channelBizChildRefId,res.channelBizRefId]:[res.channelBizChildRefId, res.channelBizRefId],
          channel: res.channel ? res.channel : 'RT',
          zoneId:res.zoneId?res.zoneId:'All',
          zoneName:res.zoneId?zoneItem[0].name:'售券中心'
        }
        this.filterMallData = this.mallData.filter(item => this.form.mallIds.indexOf(item.id) >= 0)
        if (this.$route.query.page == 'copy') {
          this.isEdit = true
          this.form.activityDate = []
        } else if (res.status == 'Doing' || res.status == 'Ended') {
          this.isCanEdit = false // 已结束、进行中、已停止 状态不能编辑
        }
        this.onTableReset(res.couponKind)
      } catch (err) {
        console.log('err: ', err);
      }

    },
    // 获取config
    async getConfigData() {
      const {mall} = await api_getConfig(['mall'])
      this.mallData = mall // 商场
    },
    // 获取售券场景
    async getActivityZoneList() {
      const res = await api_getActivityZoneList()
      this.zoneList = res
    },
    // 时间格式
    getTimeStr(str) {
      return str.slice(0,2)+':'+str.slice(2,4)+':'+str.slice(4)
    },

    // 获取优惠券列表数据
    async getCouponListData() {
      const res = await api_getListCoupon()
      this.couponListData = res
      this.couponSelectData = this.couponListData
    },

    // 获取礼品券列表数据
    async getGiftCouponListData() {
      const res = await api_getGiftListCoupon()
      this.giftCouponListData = res
    },

    // 获取抵扣券列表数据
    async getDeductCouponListData() {
      const res = await api_getDeductCouponSelect()
      this.deductCouponListData = res
    },

    // 判断该字段是否可编辑
    isKeyEdit(status){
      const { page } = this.$route.query
      return (status != "New" && page == "detail")
    },

    // 券类型改变
    onCouponKindChange(value) {
      delete this.form.couponTemplateId
      delete this.form.channelBizChild
      this.tableTrData = []
      this.couponType = value
      delete this.form.refundable
      if (this.form.channel == 'RT' && value === 'Coupon') {
        this.couponSelectData = this.couponListData

      } else if (this.form.channel == 'VoucherCenter' && value === 'Coupon') {
        this.couponSelectData = this.couponCenterListData
        this.couponType = 'CouponCenter'

      } else if (value === 'GiftCoupon') {
        this.couponSelectData = this.giftCouponListData

      } else if (value === 'WelfareCoupon') {
        this.couponSelectData = this.vcWelfareCouponListData
        this.couponType = 'vcWelfareCoupon'
        this.form.deliveryChannel = 'WelfareCoupon'
        this.form.refundable = false
      }else if (value === 'Recharge') {
        this.couponSelectData = this.vcRechargeListData
        this.couponType = 'vcRecharge'
        this.form.deliveryChannel = 'WelfareCoupon'
        this.form.refundable = false
      }else if (value === 'DeductCoupon') {
        this.couponSelectData = this.deductCouponListData
      }
      
    },
    onTableReset(value){
      if (this.form.channel == 'RT' && value === 'Coupon') {
      } else if (this.form.channel == 'VoucherCenter' && value === 'Coupon') {
        this.couponType = 'CouponCenter'
      } else if (value === 'GiftCoupon') {
      } else if (value === 'WelfareCoupon') {
        this.couponType = 'vcWelfareCoupon'
      }else if (value === 'Recharge') {
        this.couponType = 'vcRecharge'
      }
    },
    // 券下拉框改变
    onCouponChange(value) {
      if (!value) {
        return
      }
      if (this.form.channel == 'RT') {
        const curCoupon = this.couponSelectData.filter(item => item.id == value)
        this.tableTrData = curCoupon
      } else if (this.form.couponKind == 'WelfareCoupon' || this.form.couponKind == 'Recharge') {
        let curCouponChannel = this.couponSelectData.filter(item => (item.channel == value[0]))
        let curCoupon = curCouponChannel[0].children.filter(item => (item.id == value[1]))
        console.log(curCoupon)
         curCoupon.length && curCoupon[0].children.map(item => {
          if(item.id == value[2]){
            curCoupon[0].stock = item.stock
            return item
          }
        })
        this.tableTrData = JSON.parse(JSON.stringify(curCoupon))
        this.$forceUpdate()
        this.form.couponTemplateId = curCoupon.length ? curCoupon[0].couponTemplateId : ''

      } else {
        let curCoupon = this.couponSelectData.filter(item => (item.id == value[0]))
        curCoupon[0] && curCoupon[0].children.map(item => {
          if(item.id == value[1]){
            curCoupon[0].remain = item.stock
            return item
          }
        })
        this.tableTrData = JSON.parse(JSON.stringify(curCoupon))
        this.$forceUpdate()
      }
    },

    // 获取优惠券券详情
    async getCouponDetail(couponTemplateId) {
      let res = await api_getCouponDetail({id: couponTemplateId})
      this.tableTrData = res.id ? [res] : []
    },

    // 获取礼品券券详情
    async getGiftCouponDetail(couponTemplateId) {
      let res = await api_getGiftCouponDetail({id: couponTemplateId})
      this.tableTrData = res.id ? [res] : []
    },

    // 获取抵扣券券详情
    async getDeductCouponTemplate(couponTemplateId) {
      let res = await api_getDeductCouponTemplate({id: couponTemplateId})
      this.tableTrData = res.id ? [res] : []
    },

    // 获取券中台投放券详情
    async getVoucherCenterDetail(channelBizChildRefId, channelBizRefId) {
      let res = await api_getCouponTemplate({ channelBizChildRefId, channelBizRefId })
      res.id = res.refId
      this.tableTrData = res.id ? [res] : []
      this.couponSelectData = this.couponCenterListData
    },

    onZoneChange(e){
      this.form.couponKind = 'Coupon'
      this.onCouponKindChange('Coupon')
    },

    // 获取券中台福利券详情
    async getVCWelfareCouponDetail(couponTemplateId,type) {
      let res = await api_getVCWelfareCouponTemplate({id: couponTemplateId})
      res.couponTemplateId = res.id
      this.tableTrData = res.id ? [res] : []
      console.log(this.vcRechargeListData)
      switch (type) {
        case 'WelfareCoupon':
          this.couponSelectData = this.vcWelfareCouponListData
          break;
        case 'Recharge':
          this.couponSelectData = this.vcRechargeListData
          break;
        default:
          break;
      }

    },

    // 获取画像数据
    async getPortrayalData() {
      const res = await api_getListPortrait()
      this.portrayalData = res
    },

    // 获取券中台优惠券列表数据
    async getCouponCenterListData() {
      return;
      let res = await api_getCouponTemplateList()
      res = res.map(item => {
        item.id = item.refId
        item.children = item.vcPosts.map(form => {
          return {
            ...form,
            id: form.refId,
            name: `${form.name}-(${form.refId})`
          }
        })
        return item
      })
      console.log('res: ', res);
      this.couponCenterListData = res
    },

    // 获取券中台福利券券列表数据
    async getVcWelfareCouponListData(productType) {
      return;
      let res = await api_getWelfareCouponAll({productType})
      res = res.map(form => {
        form.id = form.channel
        form.name = form.channelName
        form.children = form.templateList.map(formOne => {
            formOne.couponTemplateId = formOne.id
            formOne.id = formOne.thirdId
            formOne.name = formOne.productName
            formOne.children = formOne.vcPosts.map(formTwo => {
              formTwo.id = formTwo.refId
              formTwo.name = `${formTwo.name}-(${formTwo.refId})`
              return formTwo
            })
          return formOne
        })
        return form
      })
      console.log('res: ', res);
      switch (productType) {
        case 'WelfareCoupon':
          this.vcWelfareCouponListData = res
          break;
        case 'Recharge':
          this.vcRechargeListData = res
          break;
        default:
          break;
      }

    },

    // 积分改变
    onPointChange(value) {
      this.form.point = value ? this.form.point : '0'
    },

    // 限制 单选器改变
    limitRadioChange(name) {
      this.$refs.form.validateField(name)
      this.form[name] = null
      delete this.form[name]
    },

    // 券渠道改变
    onChannelChange(value) {
      this.couponType = this.form.couponKind
      if (value == 'VoucherCenter') {
        this.form.couponKind = 'Coupon'
        this.couponType = 'CouponCenter'
        this.couponSelectData = this.couponCenterListData
      } else {
        this.form.couponKind = 'Coupon'
        this.onCouponKindChange('Coupon')
      }
      this.form.couponTemplateId = ''
      this.form.channelBizChild = ''
      setTimeout(() => {
        this.$refs['form'].clearValidate(['couponTemplateId', 'channelBizChild']);
      }, 0)
      this.tableTrData = []
    },

    // 是否隐藏券 改变事件
    onHiddenChange(value) {
      if (value) {
        // 是否是隐藏券为true时，发放用户、范围类型固定为所有用户和所有商场，并且不可编辑
        this.form = {
          ...this.form,
          deliveryChannel: this.form.channel == 'VoucherCenter' && (this.form.couponKind == 'WelfareCoupon' || this.form.couponKind == 'Recharge')? 'WelfareCoupon' : 'SellCoupon',
          sort: null,
          useRange: 'AllUser',
          scopeType: 'AllMall'
        }
      }
    },
    onDeliveryChannelChange(value){
        this.form = {
          ...this.form,
          sort: null,
        }
    },

    // 查看使用须知
    onLookRemark(row) {
      this.currentRow = row
      this.isShowRemarkDialog = true
    },

    // 时间段售卖获取焦点
    salesTimeFocus() {
      if (!this.form.salesTime) this.form.salesTime = ['000000', '235959']
    },

    // 点击提交基本信息
    onNextStep() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          console.log(this.form)
          try {
            let { activityDate, scopeType, mallIds, channel, channelBizChild, couponKind, couponTemplateId='' } = this.form
            let params = {
              ...this.form,
              startTime: activityDate && activityDate[0] ? activityDate[0] : null,
              endTime: activityDate && activityDate[1] ? activityDate[1] : null,
              mallIds: scopeType == 'Mall' ? mallIds : [],
            }

            if (channelBizChild) {
              params={
                ...params,
                channelBizChannelRefId:channel == 'VoucherCenter' && couponKind!='Coupon' ? channelBizChild[0] : '',
                channelBizChildRefId: channel == 'VoucherCenter'&& couponKind!='Coupon'  ? channelBizChild[1] : channelBizChild[0],
                channelBizRefId: channel == 'VoucherCenter' && couponKind!='Coupon' ? channelBizChild[2] : channelBizChild[1],
              }

            }

            // 是否按时间段售卖
            if (this.form.preheat == '1') {
              params.salesStartTime = this.form.salesTime[0]
              params.salesEndTime = this.form.salesTime[1]
            } else {
              delete params.salesStartTime
              delete params.salesEndTime
            }

            this.form.point==0?this.form.point=='':this.form.point
            if (this.form.zoneId == 'All') {
                delete params.zoneId
            }
            delete params.scopeType
            delete params.activityDate
            delete params.dailyTotal
            delete params.userDaily
            delete params.userTotal
            delete params.preheat
            delete params.salesTime
            if (this.$route.query.page == 'copy') {
              delete params.id
              delete params.status
              delete params.issued
            }
            !params.id && (params.disable = false) // 创建活动时默认状态
            console.log('params: ', params);
            // return

            let res = params.id ? await api_putUpdateCouponSell(params) : await api_postAddCouponSell(params)
            console.log('res: ', res);
            this.$baseMessage('操作成功', 'success')
            this.$router.push({
              query: {
                ...this.$route.query,
                id: res.id,
                page: 'detail'
              }
            })
            this.getDetailData()
            this.submitLoading = false
          } catch(error) {
            this.submitLoading = false
            console.log(error)
          }
        }
      })
    },

    // 图片上传事件
    getUploadFile (file, prizesItem) {
      prizesItem.iconKey = file
    },

    // 点击取消
    onCancel() {
      if (this.$route.query.id && this.$route.query.page === 'detail') {
        this.isEdit = false
      } else {
        this.$router.back(-1)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.m-activity-addCouponSell {
  width: 100%;
  padding: 35px 20px;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;

  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 400px;
  }

  .remark-box {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    overflow: auto;

    &::v-deep img {
      width: 100% !important;
    }
  }

  .price-input-box {
    display: flex;
    .el-input {
      width: 175px !important;
    }
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
  }

  .limit-pay-box {

    .el-radio__label {

      .el-form-item {
        display: inline-block;
        margin: 0;
        margin-left: 10px;
        .el-input {
          width: 200px !important;
        }
      }
    }
  }

  .coupon-table {
    width: 80%;
    margin-left: 160px;
    margin-bottom: 20px;
  }

  .row-info {
    min-height: 34px;
    line-height: 34px;
    margin-bottom: 20px;
    font-size: 14px;

    .col-label {
      text-align: right;
      padding-right: 20px;
      color: #666;
    }

    .col-value {
      color: #000;
    }
  }

  .winning-record {
    margin-top: 60px;

    .el-divider {
      margin-bottom: 20px;
    }
  }
  .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }

    .title-remark {
      color: #666666;
      font-size: 14px;
    }
  }

  .button-box{
    text-align: left;
    margin-top: 50px;

    &.right {
      text-align: right;
    }
  }

  .buyer-box {
    margin-top: 50px;
  }
}
</style>
